import { render } from "./competition_completed.vue?vue&type=template&id=ac1f65aa&scoped=true"
import script from "./competition_completed.vue?vue&type=script&lang=js"
export * from "./competition_completed.vue?vue&type=script&lang=js"

import "./competition_completed.vue?vue&type=style&index=0&id=ac1f65aa&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac1f65aa"]])

export default __exports__